module.exports = __webpack_public_path__ + "static/privacy-policy-0eb3d14e1a838f32ccd34883556c7607.pdf";